import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { PageMenu } from '../../../../components'
import { IconEstoqueBlue } from '../../../../assets/imgs'
import NotAllowedModule from '../../../../components/NotAllowedModule/NotAllowedModule'
import {
  menuItemsAllowed,
  TpPermissions,
  verifyTpPermission,
} from '../../../../services/permission/menus'

function EstoqueMenu({ selectedTp }) {
  const [allowed, setAllowed] = React.useState(true)

  useEffect(() => {
    const allowed = verifyTpPermission(TpPermissions.ESTOQUE, selectedTp)
    setAllowed(allowed)
  }, [selectedTp])

  const menuItems = menuItemsAllowed([
    {
      id: 110,
      content: { menu: '8.1 - Cadastro de Estoque', path: '/main/estoque/cadastro-estoque' },
    },
    {
      id: 111,
      content: {
        menu: '8.2 - Cadastro de Operação de Estoque',
        path: '/main/estoque/cadastro-operacao-estoque',
      },
    },
    {
      id: 112,
      content: {
        menu: '8.3 - Movimentação de Estoque - Recebimento',
        path: '/main/estoque/movimentacao-estoque-recebimento',
      },
    },
    {
      id: 113,
      content: {
        menu: '8.4 - Movimentação de Estoque - Transferência',
        path: '/main/estoque/movimentacao-estoque-transferencia',
      },
    },
    {
      id: 114,
      content: {
        menu: '8.5 - Movimentação de Estoque - Expedição',
        path: '/main/estoque/movimentacao-estoque-expedicao',
      },
    },
    {
      id: 44,
      content: {
        menu: '8.6 - Movimentação de Estoque - Avulso',
        path: '/main/estoque/movimentacao-estoque-avulso',
      },
    },
    {
      id: 115,
      content: {
        menu: '8.7 - Relatório de Posição de Estoque',
        path: '/main/estoque/ver-estoque',
      },
    },
    {
      id: 116,
      content: {
        menu: '8.8 - Relatório de Estadia por Empresa',
        path: '/main/estoque/relatorio-estadia',
      },
    },
    {
      id: 117,
      content: { menu: '8.9 - Inventario', path: '/main/estoque/inventario' },
    },
    {
      id: 118,
      content: {
        menu: '8.10 - Movimentações por Tipo de Operação de Estoque',
        path: '/main/estoque/movimentacao-por-tipo-operacao',
      },
    },
    {
      id: 119,
      content: {
        menu: '8.11 - Extrato de Movimentação por Posição de Estoque',
        path: '/main/estoque/extrato-movimentacao-por-posicao',
      },
    },
    {
      id: 120,
      content: {
        menu: '8.12 - Relatório de Inventario por Posição',
        path: '/main/estoque/relatorio-inventario-posicao',
      },
    },
    {
      id: 121,
      content: {
        menu: '8.13 - Relatório de Recall de Produto',
        path: '/main/estoque/relatorio-recall-produto',
      },
    },
    {
      id: 122,
      content: {
        menu: '8.14 - Gerenciamento de Posições de Estoque',
        path: '/main/estoque/gerenciamento-posicoes-estoque',
      },
    },
    {
      id: 123,
      content: {
        menu: '8.15 - Cadastro de Motivo de Bloqueio de Posição Estoque',
        path: '/main/estoque/motivo-bloqueio-posicao-estoque',
      },
    },
    {
      id: 124,
      content: {
        menu: '8.16 - Relatório de Saldo de Estoque',
        path: '/main/estoque/relatorio-saldo-estoque',
      },
    },
    {
      id: 125,
      content: {
        menu: '8.17 - Relatório de Etiquetas Internadas no Estoque',
        path: '/main/estoque/relatorio-etiquetas-internadas',
      },
    },
    {
      id: 126,
      content: {
        menu: '8.18 - Relatório de Posições de Estoque Ocupadas Diária',
        path: '/main/estoque/relatorio-posicoes-estoque-diaria',
      },
    },
    {
      id: 127,
      content: {
        menu: '8.19 - Extrato de Movimentação Por Produto',
        path: '/main/estoque/extrato-movimentacao-por-produto',
      },
    },
    {
      id: 128,
      content: {
        menu: '8.20 - Ordem de Carregamento - Prevista',
        path: '/main/estoque/ordem-carregamento-prevista',
      },
    },
    {
      id: 129,
      content: {
        menu: '8.21 - Cadastro Status Etiqueta - Estoque',
        path: '/main/estoque/cadastro-status-etiqueta-estoque',
      },
    },
    {
      id: 136,
      content: {
        menu: '8.22 - Relatório de Estoque por Produto',
        path: '/main/estoque/relatorio-estoque-por-produto',
      },
    },
    {
      id: 141,
      content: {
        menu: '8.23 - Relatório de Posições de Etiquetas por Cliente',
        path: '/main/estoque/relatorio-posicoes-etiquetas-cliente',
      },
    },
    {
      id: 142,
      content: {
        menu: '8.24 - Comparativo Entrada Avulso - Picking X Picking',
        path: '/main/estoque/comparativo-entrada-avulso-picking',
      },
    },
  ])

  return (
    <>
      <PageMenu menuItems={allowed ? menuItems : []}>
        <img src={IconEstoqueBlue} alt="Icon Tela de Estoque" />
        <span style={{ display: 'inline-block', marginLeft: 10 }}>8. Estoque</span>
      </PageMenu>{' '}
      {!allowed && <NotAllowedModule />}
    </>
  )
}

const mapStateToProp = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProp)(withRouter(EstoqueMenu))
